@switch (columnName) {
  @case ('name') {
    {{ element['name'] }}
    @if (element.isGloballyAvailableForProductOwners) {
      <mat-icon
        [matTooltip]="'thisIsGloballyAvailablePrivilegeTemplateForProductOwners' | translate"
      >
        public
      </mat-icon>
    }
  }
  @default {
    {{ element[columnName] }}
  }
}
